import { render, staticRenderFns } from "./GuideLinks.vue?vue&type=template&id=08a1b3a2&scoped=true"
import script from "./GuideLinks.vue?vue&type=script&lang=js"
export * from "./GuideLinks.vue?vue&type=script&lang=js"
import style0 from "./GuideLinks.vue?vue&type=style&index=0&id=08a1b3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1b3a2",
  null
  
)

export default component.exports